import cx from 'classnames';
import { Icon, Spinner, Text } from '../../atoms';
import DropzoneClear from '../Dropzone/components/DropzoneClear';
import DropzoneDrag from '../Dropzone/components/DropzoneDrag';
import DropzoneFilename from '../Dropzone/components/DropzoneFilename';
import DropzoneSupportedFormats from '../Dropzone/components/DropzoneSupportedFormats';
import DropzoneTrigger from '../Dropzone/components/DropzoneTrigger';
import styles from './DropzoneContent.module.scss';
import { DropzoneContentProps } from './DropzoneContent.types';

const DropzoneContent = (props: DropzoneContentProps) => {
  return (
    <div
      className={cx(
        styles.dropzoneContent,
        styles[`type--${props.type}`],
        props.className,
      )}
    >
      <div className={styles.infoTextAndButtonContainer}>
        <Text
          className={styles.infoText}
          type="BodySmall"
          weight="Medium"
        >
          Drag & Drop or
        </Text>
        <DropzoneTrigger
          className={styles.dropzoneFileUploadTriggerChooseFileButton}
          appearance="Default"
          type="Outlined"
          style="Secondary"
          size="Medium"
        >
          Choose File
        </DropzoneTrigger>
      </div>
      <DropzoneDrag className={styles.dropzoneDrag} />
      <Spinner
        className={styles.loaderAnim}
      />
      <DropzoneFilename className={styles.dropzoneFileName} />
      <DropzoneSupportedFormats
        className={styles.dropzoneSupportedFormats}
      />
      <DropzoneClear
        className={styles.dropzoneRemoveUploadButtonDeleteButton}
        appearance="Default"
        type="Ghost"
        style="Secondary"
        size="Medium"
        icon={(
          <Icon
            className={
              styles.dropzoneRemoveUploadButtonDeleteButtoncloseDelete
            }
            style="Outlined"
            size="Medium"
            icon="CloseDelete"
          />
        )}
      />
    </div>
  );
};

export default DropzoneContent;
